import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import Dropzone from 'react-dropzone';
import EmptyState from 'components/project/empty_state';

import { createFile } from '../store/actions/import_object';

export class SelectFile extends React.Component {
  static propTypes = {
    files: PropTypes.array.isRequired,
    onAddFile: PropTypes.func.isRequired
  }

  handleDrop = (files) => {
    const { onAddFile } = this.props;
    if (files.length === 0) return;

    const file = files[0];

    const formData = new FormData();
    formData.append('upload', file);
    onAddFile(formData);
  }

  render() {
    return (
      <div className="mv-4 mh-4">
        <div className="panel-body pt-0">
          {this.renderDropZone()}
        </div>
      </div>
    );
  }

  renderDropZone() {
    return (
      <React.Fragment>
        <div className="mb-5 csv-uploader">
          <Dropzone
            accept=".csv"
            multiple={false}
            onDrop={this.handleDrop}
          >
            {({ getRootProps, getInputProps }) => (
              <div className="csv-uploader-target" {...getRootProps()}>
                {this.renderDropBox()}
                <input {...getInputProps()} />
              </div>
            )}
          </Dropzone>
        </div>
      </React.Fragment>
    );
  }

  renderDropBox() {
    const { files } = this.props;

    if (Object.keys(files).length > 0) {
      return (
        <div className="text-center text-muted">
          Click or drop additional spreadsheets here to upload
        </div>
      );
    } else {
      return (
        <EmptyState
          imageSrc="/images/importer/upload_icon.svg"
          message="Upload CSV File(s) to Import"
          subMessage="Select File(s) or drop them here to upload"
        />
      );
    }
  }
}

const mapStateToProps = state => ({
  files: state.importObject.files
});

const mapDispatchToProps = {
  onAddFile: createFile
};

export default connect(mapStateToProps, mapDispatchToProps)(SelectFile);
